import {fontStyles, theme} from '@styles/theme';
import styled from 'styled-components';

export const RadioButtonWrapper = styled.label<{active?: boolean}>`
  display: flex;
  align-items: center;
  position: relative;
  label {
    ${fontStyles.bodyR}
    margin-left: 5px;
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    border-radius: ${theme.roundedBig};
    height: ${({active}: {active?: boolean}) => (active ? `20px` : '16px')};
    width: ${({active}: {active?: boolean}) => (active ? `20px` : '16px')};
    margin: ${({active}: {active?: boolean}) => (active ? 0 : '2px')};
    border: 2px solid ${theme.colors.basic03};
    transition: 0.2s all fade;
    outline: none;

    top: -1px;
    &:before {
      position: absolute;
      content: '';
      width: 6px;
      height: 6px;
      background-color: transparent;
      border-radius: ${theme.roundedBig};
      top: 5px;
      left: 5px;
    }
  }

  input:checked {
    position: relative;
    border: 2px solid ${theme.colors.signalGreen01};
    background-color: ${theme.colors.signalGreen00};
    &:before {
      background-color: ${theme.colors.basic08};
    }
  }
`;

export const RadioButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
